import React, { ReactNode, useRef, useState } from 'react';

import { Container } from 'common/components/DropDownMenu/DropDownMenu.styled';
import { ItemModel } from 'common/components/DropDownMenu/ItemModel';
import { MenuList } from 'common/components/DropDownMenu/MenuList';
import { MenuToggle } from 'common/components/DropDownMenu/MenuToggle';
import { useOnClickOutside } from 'common/hooks';

interface IProps {
  items: ItemModel[];
  menuToggleIcon?: ReactNode;
  position?: string;
  notchPosition?: string;
}

export const DropDownMenu = ({ items, menuToggleIcon, position, notchPosition }: IProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);
  useOnClickOutside(
    ref,
    () => {
      if (isVisible) {
        setIsVisible(false);
      }
    },
    'mousedown',
  );

  return (
    <Container ref={ref}>
      <MenuToggle onToggle={() => setIsVisible(!isVisible)} menuToggleIcon={menuToggleIcon} />
      <MenuList
        notchPosition={notchPosition}
        items={items}
        position={position}
        isVisible={isVisible}
        onOutsideClick={() => setIsVisible(false)}
      />
    </Container>
  );
};
